<template>
    <Modal2
        @cancel="$emit('close')"
        :show-footer="false"
        :title="$t('message.sendTemplateMessage')"
        className="template-message-modal"
    >
        <div class="template-message-modal">
            <div class="template-message-modal-content">
                <div class="template-message-modal-preview">
                    <WABATemplateMessage :data="getPreviewTemplatePayload()" :float="'left'" />
                </div>
                <div class="template-message-modal-content-editor">
                    <div class="image-picker" v-if="['IMAGE', 'VIDEO', 'DOCUMENT'].includes(template.templateType)">
                        <div class="editor-row">
                            <div
                                class="editor-row-title"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="$t('message.templateMediaCustomizeTooltip')"
                            >
                                {{ $t("message.mediaLabelShort") }}
                                <span class="optional">{{ $t("whatsapp_business_api.optional") }}</span>
                                <a-icon type="question-circle" />
                            </div>
                            <div class="media-preview" v-if="media">
                                <div class="media-preview-content">
                                    <div class="media-image">
                                        <img :src="media.data" alt="" />
                                    </div>
                                    <div class="media-preview-name">
                                        {{ media.name }}
                                    </div>
                                </div>
                                <div class="media-preview-delete" @click="deleteMedia">
                                    <div class="material-icons">delete</div>
                                </div>
                            </div>
                            <div class="media-drag" v-else>
                                <div class="input">
                                    <input
                                        type="file"
                                        id="media-source"
                                        :accept="getAcceptType()"
                                        @change="handleFileUpload"
                                    />
                                </div>
                                <div class="material-icons">image</div>
                                <div class="content">{{ $t("auto.clickHereToUploadPicture") }}</div>
                            </div>
                            <span class="description">
                                <div class="input-warn">
                                    <div>
                                        <b>{{ $t("auto.note") }}:</b> {{ $t("auto.acceptedFileFormatsAndSizes") }}
                                    </div>
                                    <ul class="list-item">
                                        <li>{{ $t("auto.imageJpegPngMax2Mb") }}</li>
                                        <li>{{ $t("auto.videoMp4Max20Mb") }}</li>
                                        <li>{{ $t("auto.documentMax2Mb") }}</li>
                                    </ul>
                                </div>
                            </span>
                        </div>
                    </div>
                    <div class="template-message-modal-params">
                        <div v-if="headerParams.length > 0" class="param-category">
                            <div class="param-category-title">{{ $t("auto.headerParameters") }}</div>
                            <div v-for="(param, index) in headerParams" :key="'header-' + index" class="editor-row">
                                <div>{{ $t("auto.headerParameter") }} {{ index + 1 }}</div>
                                <a-textarea v-model="headerParams[index]" :placeholder="$t('auto.headerParameterValue')" class="full-width-textarea" />
                            </div>
                        </div>

                        <div v-if="bodyParams.length > 0" class="param-category">
                            <div class="param-category-title">{{ $t("auto.bodyParameters") }}</div>
                            <div v-for="(param, index) in bodyParams" :key="'body-' + index" class="editor-row">
                                <div>{{ $t("auto.bodyParameter") }} {{ index + 1 }}</div>
                                <a-textarea v-model="bodyParams[index]" :placeholder="$t('auto.bodyParameterValue')" class="full-width-textarea" />
                            </div>
                        </div>

                        <div v-if="carouselParams.length > 0" class="param-category">
                            <div class="param-category-title">{{ $t("auto.carouselParameters") }}</div>
                            <div v-for="(param, index) in carouselParams" :key="'carousel-' + index" class="editor-row">
                                <div>{{ $t("auto.carouselParameter") }} {{ index + 1 }}</div>
                                <a-textarea v-model="carouselParams[index]" :placeholder="$t('auto.carouselParameterValue')" class="full-width-textarea" />
                            </div>
                        </div>

                        <div v-if="buttonParams.length > 0" class="param-category">
                            <div class="param-category-title">{{ $t("auto.buttonParameters") }}</div>
                            <div v-for="(param, index) in buttonParams" :key="'button-' + index" class="editor-row">
                                <div>{{ $t("auto.buttonParameter") }} {{ index + 1 }}</div>
                                <a-textarea v-model="buttonParams[index]" :placeholder="$t('auto.buttonParameterValue')" class="full-width-textarea" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="template-message-modal-actions">
                <SupsisButton @click="$emit('send', getPayload())" primary>{{ $t("auto.send") }}</SupsisButton>
                <SupsisButton @click="$emit('close')" ghost>{{ $t("auto.cancel") }}</SupsisButton>
            </div>
        </div>
    </Modal2>
</template>
<script>
import Modal2 from "../../../../../common/Modal2.vue";
import WABATemplateMessage from "../../../../messages/WABATemplateMessage.vue";
import { mapState } from "vuex";
import _ from "lodash";
import SupsisButton from "../../../../../../views/Pages/Settings/components/SupsisButton.vue";
import { uploadAsset } from "../../../../../../api/assetUpload";
import axios from "axios";

export default {
    name: "TemplateMessageModal",
    components: { SupsisButton, WABATemplateMessage, Modal2 },
    props: {
        channelId: {
            type: String,
            default: "",
        },
        template: {
            type: Object,
            default: {},
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            user: (state) => state.auth.user,
        }),
    },
    data: () => {
        return {
            media: null,
            asset: {},
            headerParams: [],
            bodyParams: [],
            carouselParams: [],
            buttonParams: [],
        };
    },
    mounted() {
        this.initializeParams();
    },
    methods: {
        initializeParams() {
            const template = this.template;
            const templateType = template.templateType;
            const containerMetaObj = JSON.parse(template.containerMeta);
            const headerText = _.get(containerMetaObj, "header", "");

            // Header parametreleri
            const headerMatches = headerText.match(/{{\d+}}/g);
            this.headerParams = headerMatches ? headerMatches.map(() => "") : [];

            // Body parametreleri
            const bodyMatches = containerMetaObj.data.match(/{{\d+}}/g);
            this.bodyParams = bodyMatches ? bodyMatches.map(() => "") : [];

            // Carousel parametreleri
            let cardVariableSize = 0;
            if (templateType === "CAROUSEL") {
                const cards = containerMetaObj.cards;
                cardVariableSize = cards
                    .map((card) => {
                        return card.body.match(/{{\d+}}/g);
                    })
                    .flat()
                    .filter(Boolean).length;
            }
            this.carouselParams = new Array(cardVariableSize).fill("");

            // Button parametreleri
            const buttonVariableSize = (containerMetaObj.buttons || []).filter((button) => button.type === "URL").map((button) => {
                return button.url.match(/{{\d+}}/g);
            }).flat().filter(Boolean).length;
            this.buttonParams = new Array(buttonVariableSize).fill("");
        },
        getPayload() {
            const template = this.template;
            if (this.asset) template.asset = this.asset;
            return {
                template,
                params: [...this.headerParams, ...this.bodyParams, ...this.carouselParams, ...this.buttonParams],
            };
        },
        getPreviewTemplatePayload() {
            return {
                username: this.user.name,
                payload: {
                    ...this.template,
                    params: [...this.headerParams, ...this.bodyParams, ...this.carouselParams, ...this.buttonParams],
                },
            };
        },
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const imageMime = ["image/jpeg", "image/png"];
                const videoMime = ["video/mp4"];
                const pdfMimeType = ["application/pdf"];
                const mb = file.size / 1024 / 1024;
                if (imageMime.includes(file.type) && mb >= 2) {
                    this.$message.error("The image could not be uploaded because it is more than 2 MB.", 3);
                    return;
                }
                if (videoMime.includes(file.type) && mb >= 20) {
                    this.$message.error("The video could not be uploaded because it is more than 20 MB.", 3);
                    return;
                }

                if (pdfMimeType.includes(file.type) && mb >= 2) {
                    this.$message.error("The document could not be uploaded because it is more than 2 MB.", 3);
                    return;
                }

                this.$message.loading("Image uploading, please wait...", 5);

                let path = `${this.siteId}/whatsapp-business/${this.channelId}/assets/`;
                let imgUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "gupshup-file",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });

                await axios({
                    method: imgUploadData.data.method,
                    url: imgUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": file.type },
                });

                this.media = {
                    data: URL.createObjectURL(file),
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    asset: {
                        id: imgUploadData.data.asset.id,
                        url:
                            imgUploadData.data.asset.v2Format && imgUploadData.data.asset.cdnUrl
                                ? imgUploadData.data.asset.cdnUrl
                                : `https://static.supsis.live/${imgUploadData.data.asset.path}${imgUploadData.data.asset.id}.${imgUploadData.data.asset.ext}`,
                        name: file.name,
                        ext: imgUploadData.data.asset.ext,
                        path: imgUploadData.data.asset.path,
                        v2Format: imgUploadData.data.asset.v2Format,
                        fromUI: true,
                    },
                };

                this.asset = this.media.asset;
                this.$message.success("Resim başarılı bir şekilde yüklendi.");
            }
        },
        getAcceptType() {
            const templateType = this.template.templateType;
            let types = [];
            if (templateType === "IMAGE") {
                types = _.concat(types, ["image/jpeg", "image/png"]);
            } else if (templateType === "VIDEO") {
                types = _.concat(types, ["video/mp4"]);
            } else if (templateType === "VIDEO") {
                types = _.concat(types, ["application/pdf"]);
            }
            // here
            return types.join(" ,");
        },
        deleteMedia() {
            this.media = null;
            this.asset = null;
        },
    },
    watch: {
        template: {
            handler() {
                this.initializeParams();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.template-message-modal {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &-preview {
        width: 100%;
        overflow: hidden;
    }

    &-content {
        display: flex;
        gap: 20px;
        width: 100%;
        &-editor {
            width: 100%;
        }
    }

    &-actions {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
    }

    .image-picker {
        margin-top: 15px;

        .input-warn {
            background: #fff6e6;
            padding: 20px;

            .list-item {
                padding-left: 15px;
            }
        }

        .media-preview {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .media-preview-content {
                display: flex;
                align-items: center;
                gap: 10px;

                .media-preview-name {
                    font-weight: bold;
                }

                .media-image img {
                    height: 100px;
                }
            }

            .media-preview-delete {
                background: red;
                padding: 5px;
                border-radius: 100%;
                color: white;
                line-height: 0;
            }
        }

        .media-drag {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 10px;
            border: 1px solid var(--color-border-default);
            padding: 40px;
            cursor: pointer;
            position: relative;

            .input {
                width: 100%;
                height: 100%;

                input {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    opacity: 0;
                }
            }

            .material-icons {
                font-size: 28px;
            }

            .content {
                font-size: 18px;
                font-weight: bold;
            }
        }
    }

    .template-message-modal-params {
        width: 100%;

        .param-category {
            margin-bottom: 20px;

            .param-category-title {
                font-weight: bold;
                margin-bottom: 10px;
                padding: 10px;
                background-color: #f5f5f5;
                border-radius: 4px;
                border-left: 4px solid #1890ff;
            }
        }

        .editor-row {
            width: 100%;
            margin-bottom: 10px;
        }

        .full-width-textarea {
            width: 100%;
        }
    }
}
</style>
<style lang="scss">
.template-message-modal {
    .ant-modal {
        width: 700px !important;
    }
}
</style>
